/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgNvd = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <path
        d="M23 11.789c-.005-1.665-1.08-2.352-1.787-2.623A2.553 2.553 0 0 0 20.298 9H15.41a.717.717 0 0 0-.632.378l-1.807 3.37s-.233.487-.307.487h-.095c-.074 0-.307-.486-.307-.486L10.252 9H8.749l2.614 4.849s.402.735 1.206.735h.095c.804 0 1.206-.735 1.206-.735l1.907-3.538h4.36c1.406 0 1.545 1.387 1.553 1.483-.008.096-.147 1.483-1.552 1.483h-2.68c-.193 0-.183-.23-.183-.23v-2.246h-1.312v3.783h1.46v.004h2.875c.313 0 .623-.054.915-.166.707-.272 1.782-.958 1.787-2.623v-.01zM2.48 9.007A1.48 1.48 0 0 0 1 10.487l.011 4.111h1.316l-.011-2.735v-1.376c0-.085.065-.156.148-.165h.016c.045 0 .086.019.116.049l3.452 3.787a1.48 1.48 0 0 0 2.526-1.046V9H7.26v4.118a.165.165 0 0 1-.28.11L3.525 9.44a1.475 1.475 0 0 0-1.046-.434z"
        fill="currentcolor"
      />
    </g>
  </Icon>
);
export { SvgNvd as Nvd };
